import { render, staticRenderFns } from "./StatusItem.vue?vue&type=template&id=37121b9c&scoped=true&"
import script from "./StatusItem.vue?vue&type=script&lang=js&"
export * from "./StatusItem.vue?vue&type=script&lang=js&"
import style0 from "./StatusItem.vue?vue&type=style&index=0&id=37121b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37121b9c",
  null
  
)

export default component.exports